module.exports = __webpack_public_path__ + "static/media/aktiva-tetap.b8246b87.svg";